module.exports = __webpack_public_path__ + "static/media/ic_back.c05d5a2a.svg";